<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}
          <span v-if="onGongingNumber > 0"> (当前任务剩余进行数:{{onGongingNumber}})</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="3">
        <router-link :to="{ path: '/teke_tag/form'}">
          <el-button type="primary">新建标签</el-button>
        </router-link>
      </el-col>
      <el-col :span="3">
        <el-upload class="upload-demo"
                   ref="upload"
                   action=""
                   :auto-upload="false"
                   :on-change="query => onUploadFile(query)"
                   accept=".xlsx,.xls"
                   :show-file-list="false">
          <el-button type="primary">批量修改标签</el-button>
        </el-upload>
      </el-col>
      <el-col :span="3">
        <el-upload class="upload-demo"
                   ref="upload"
                   action=""
                   :auto-upload="false"
                   :on-change="query => onUploadZip(query)"
                   :show-file-list="false">
          <el-button type="primary">批量添加标签库</el-button>
        </el-upload>
      </el-col>
      <el-col :span="3">
        <router-link :to="{ path: '/teke_tag/infinite_upload_table?number=0'}">
          <el-button type="primary">上传列表</el-button>
        </router-link>
      </el-col>
      <el-col :span="3">
        <el-button type="primary"
                   @click="onDownTagFile()">下载
        </el-button>
      </el-col>

      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="标签类别id"></el-table-column>
        <el-table-column prop="tagname"
                         label="标签类别"></el-table-column>
        <el-table-column prop="tagdesc"
                         label="标签描述"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="{ path: '/teke_tag/update/'+scope.row.id}">
              <el-button type="text"
                         size="mini">修改
              </el-button>
            </router-link>
            <router-link
              :to="{ path: '/teke_tag/infinite_table',query:{pid:scope.row.id,level:(Number(parseInt(scope.row.level)+1))}}">
              <el-button type="text"
                         size="mini">标签管理
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       @click="deleteTag(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      onGongingNumber: 0,
      multipleSelection: [],
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        tagid: this.$route.params.tagid,
        level: 0,
      },
      // 搜索字段申明
      searchFieldType: {
        tagid: Number,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    return request.page('getBatchjobOnGoingNumber').then(({data}) => {
      this.onGongingNumber = data
    })
  },
  methods: {
    ...Vuex.mapActions(['getTekeTagTable', 'deleteTekeTag', 'getBatchjobOnGoingNumber']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTekeTagTable', params)
    },
    deleteTag (id) {
      return request.common('deleteTekeTag', id).then((res) => {
        this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onUploadFile (file) {
      let isLt5M = file.raw.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('大小不能超过5MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      return request.common('batchUploadTekeTagEdit', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    onUploadZip (file) {
      console.log(file.raw.type)
      let isExcel = ((file.raw.type === 'application/zip') || (file.raw.type === 'application/x-zip-compressed'))
      let isLt100M = file.raw.size / 1024 / 1024 < 100
      if (!isExcel) {
        this.$message.error('请上传zip压缩包!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt100M) {
        this.$message.error('大小不能超过100MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      return request.common('batchUploadTekeTagLib', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },

    onDownTagFile () {
      return request.common('downloadAllTagFile').then(({data}) => {
        this.$message({
          showClose: true,
          message: '请求成功，请在上传列表中下载对应文件',
          type: 'success',
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-tag/pages/TekeTagTable.vue